import Icon from '~/src/common/components/Icon';
import Link from '~/src/common/components/Link';
import Sticker from '~/src/common/components/Sticker';
import { ImageParams } from '~/src/common/typings/image';
import { getImageUrl } from '~/src/common/utils/cloudinary';

import { useNavigationTracking } from '../tracking';
import type * as T from '../types';

import styles from './MiniMenu.module.scss';

interface Props {
  family: T.Family;
}

const MiniMenu = ({ family }: Props) => {
  const { categories } = family;
  const { onClickCategoryName } = useNavigationTracking().small;

  return (
    <div className={styles.container}>
      {categories.map(({ id, name, slug, label, image }) => (
        <Link
          key={id}
          href={`/categorie/${slug}`}
          onClick={() => onClickCategoryName(id)}
          className={styles.item}>
          <img
            src={getImageUrl(image, ImageParams.familyCategory)}
            alt={name}
            className={styles.image}
          />
          <strong className={styles.name}>{name}</strong>
          {label && (
            <Sticker bg={label.bg} fg={label.fg}>
              {label.text}
            </Sticker>
          )}
          <Icon name="chevron-right" className={styles.arrow} />
        </Link>
      ))}
    </div>
  );
};

export default MiniMenu;
